module.exports = __webpack_public_path__ + "static/media/nucleo-icons.5c78b4cf.woff2";